import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  Backdrop,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useFormik } from "formik";
import React, { use, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { cfpBaseUrl } from "../../../network/urls";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import {
  readPersistedAdminCompanyCode,
  resolveAdminDiscoOfficeCode,
  resolveDiscoCompanyCodeForBranding,
} from "../../../utils/adminCompany";
import {
  applyCustomerIdLengthValidation,
  isValidCustomerIdLength,
} from "../../../utils/customerIdValidation";
import "./ReconnectionForm.scss";
import DownloadIcon from "@mui/icons-material/Download";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import Dialog from "@mui/material/Dialog";
import FormSubmissionSuccessDialog from "../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import JsBarcode from "jsbarcode";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomerInformationCard from "../../../components/CustomerInformationCard/CustomerInformationCard";
import Error from "../../../components/error/error";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
import print from "../../../images/print.png";
import {
  applicationName,
  calculateInstallments,
  calculateInstallmentsForRco,
  companyName,
  companyShortName,
  convertDate,
  convertDateDDMMYY,
  dBillAPI,
  disconnectionDetails,
  divisionName,
  downloadBill,
  getFixedChargesForRco,
  getMeterType,
  getPermissions,
  getPhase,
  getReconnectionFee,
  getRelevantCFCCode,
  handleFileUpload,
  isImage,
  isOneYearOld,
  isPdf,
  numberFormatting,
  printStamp,
  subDivAPI,
  subdivisionName,
} from "../../../services/Functions";
import batchIcon from "../../../images/batchWarning.png";
import CloseIcon from "@mui/icons-material/Close";
import pdfIcon from "../../../images/pdfIcon.png";
import { SearchIndividualApplication } from "../../../network/APIs/APIs";
import DescriptionIcon from "@mui/icons-material/Description";
import StepProgressBar from "../../../components/StepProgressBarForm/StepProgressBar";
const ReconnectionForm = () => {
  const applicantStatusForValidation = ["Owner", "Tenant"];

  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: "",
    iv_reference_number: "",
    iv_circle: "",
    iv_division: "",
    iv_sub_divison: "",
    iv_address: "",
    // Installment Details field
    iv_bill_month: "",
    iv_net_bill: "",
    iv_arrears: "",
    // Applicant Details group Initial Values
    iv_applicant_name: "",
    iv_father_name: "",
    iv_applicant_cnic: "",
    iv_applicant_phone_no: "",
    iv_applicant_email: "",
    iv_is_bill_paid: "Owner",
    iv_want_installments: "No",
    iv_reconnection_fee: "",
    iv_ed_code: "",
    iv_current_bill: "",
    iv_lps: "",
    iv_bill_adj: "",
    iv_prev_installment: "",
    iv_fixed_charges: "",
    iv_total_amount: "",
    iv_grand_total: "",
    // Required Documents Initial Values
    iv_copy_of_paid_bill: null,
    iv_connection_type: "",
    iv_tariff_description: "",
    iv_tariff_code: "",
    iv_cc_code: "",
    iv_down_payment: 0,
    iv_disconnection_date: null,
    iv_meter_serial_no: "",
    iv_bill_payment_date: "",
    iv_sanctioned_load: "",
    iv_payment_13: "",
    iv_areaType: "",
    iv_disconnection_date: "",
    iv_arrears_at_discon: "",
    iv_security_amount: "",
    iv_meter_type: "",
    iv_phase: "",
    iv_total_fpa: "",
    iv_outstanding: "",
    iv_det_amount: "",
    iv_det_month: "",
    iv_total_amount: "",
    iv_METER_TYPE: "",
    iv_KWH_MFG_ID_METER: "",
    iv_KWH_METER_CODE: "",
    iv_KWH_METER_LOC_CD: "",
    iv_KWH_STATUS: "",
    iv_KWH_METER_RANGE: "",
    iv_KWH_READING: "",
    iv_KWH_MF: "",
    iv_KVARH_READING: "",
    iv_MDI_READING: "",
    iv_MDI_CUM_READ: "",
    iv_applicant_cnic_front: "",
    iv_applicant_cnic_back: "",
    iv_consumer_status: "",
    iv_billing_month: "",
    iv_security_amount: "",
    iv_applicant_status: "Owner",
  };
  // Classification Group States
  const [referenceNumber, setReferenceNumber] = useState("");
  const [subDivision, setSubDivision] = React.useState({
    code: null,
    name: "",
  });
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [reconnectionPopUp, setReconnectionPopUp] = useState();
  const navigate = useNavigate();
  const [searchBy, setSearchBy] = useState("consumerId");
  const [disconnectionStatus, setDisconnectionStatus] = useState(null);
  const [checkArrears, setCheckArrears] = useState(null);
  // Documents states
  const [pageTitle, setPageTitle] = useState("Reconnection (RCO) Form");
  const [applicantCnicFront, setApplicantCnicDocumentFront] = useState("");
  const [applicantCnicFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] =
    useState("");
  const [applicantCnicBack, setApplicantCnicDocumentBack] = useState("");
  const [applicantCnicBackThumbnail, setApplicantCnicDocumentBackThumbnail] =
    useState("");
const [isNetMetering, setIsNetMetering] = useState(false);
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState("");
  const [applicantCnicBackError, setApplicantCnicBackError] = useState("");
  const [installmentsArray, setInstallmentsArray] = useState([]);
  const [maxBillAmount, setMaxBillAmount] = useState(0);
  const [isDetectionBill, setIsDetectionBill] = useState(false);
  const [unpaidDebt, setUnpaidDebt] = useState(null);
  const [installmentsProvisions, setInstallmentProvisions] = useState();
  let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));
  const [rcoVoucherRates, setRcoVoucherRates] = useState([
    {
      arrearAmountFrom: 0.0,
      arrearAmountTo: 5000.0,
      reconnectionFee: 500.0,
      description: "Arrears up to Rs. 5000",
    },
    {
      arrearAmountFrom: 5001.0,
      arrearAmountTo: 20000.0,
      reconnectionFee: 800.0,
      description: "Arrears between Rs. 5001/- and Rs. 20000/-",
    },
    {
      arrearAmountFrom: 20001.0,
      arrearAmountTo: 100000.0,
      reconnectionFee: 2000.0,
      description: "Arrears between Rs. 20001/- and Rs. 100000",
    },
    {
      arrearAmountFrom: 100001.0,
      arrearAmountTo: 1000000.0,
      reconnectionFee: 4000.0,
      description: "Arrears between Rs. 100001/- and Rs. 1000000",
    },
    {
      arrearAmountFrom: 1000000.0,
      arrearAmountTo: 99999999999.0,
      reconnectionFee: 10000.0,
      description: "Arrears over Rs. 1000000",
    },
    {
      arrearAmountFrom: null,
      arrearAmountTo: null,
      reconnectionFee: 2000.0,
      description:
        "Disconnection of electricity supply due to dishonest abstraction of electricity",
    },
    {
      arrearAmountFrom: null,
      arrearAmountTo: null,
      reconnectionFee: 0.0,
      description: "Seasonal Consumer",
    },
  ]);
  const [approvalFromSameOffice, setApprovalFromSameOffice] = useState(false);
  const { data: installmentProvisions } = useSelector(
    (state) => state.provisions,
  );

  const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));

  // States for hiding conditional fields
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [error, setError] = useState();
  const [downloadBillPopup, setDownloadBillPopup] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const {
    token,
    code: userCode,
    userId,
    roleId,
    cfcLevelId,
    csc,
    companyCode,
    selectedAdminCompanyCode,
  } = useSelector((state) => state.auth);
  const [minDownPayment, setMinDownPayment] = useState(0);
  const [rcoFeeVoucherDetails, setRcoFeeVoucherDetails] = useState({
    applicationId: "",
    issueDate: null,
    dueDate: null,
    fixedChargesAmount: null,
    rcoFeeAmount: null,
  });

  const [billInstallmentApplicationId, setBillInstallmentApplicationId] =
    useState("");

  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions"),
  );

  const effectiveAdminCompanyCode =
    selectedAdminCompanyCode || readPersistedAdminCompanyCode();

  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    effectiveAdminCompanyCode,
  );

  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  const [coaStatusBarArray, setCoaStatusBarArray] = useState([
    {
      title1: "APPLICATION",
      title2: "DETAIL",
      status: 0,
    },
    {
      title1: `APPLICANT'S`,
      title2: "CNIC",
      status: 0,
    },
  ]);
  const errorCloses = () => {
    setError("");
  };

  const ApplicantCnicDocumentFront = (event) => {
    const newFileName =
      "copyOfApplicantCNICFront." + event.target.files[0].name.split(".").pop();
    handleFileUpload(
      event,
      handleChange,
      setApplicantCnicDocumentFront,
      setApplicantCnicFrontError,
      setApplicantCnicDocumentFrontThumbnail,
      newFileName,
    );
  };

  const ApplicantCnicDocumentBack = (event) => {
    const newFileName =
      "copyOfApplicantCNICBack." + event.target.files[0].name.split(".").pop();
    handleFileUpload(
      event,
      handleChange,
      setApplicantCnicDocumentBack,
      setApplicantCnicBackError,
      setApplicantCnicDocumentBackThumbnail,
      newFileName,
    );
  };
  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle("");
    setDefaultDivision("");
    setError("");
    setSubDivision("");
    setIsNetMetering(false);
    values.iv_payment_13 = "";
    values.iv_meter_type = "";
    values.iv_phase = "";
    values.iv_disconnection_date = "";
    values.iv_arrears_at_discon = "";
    values.iv_due_date = "";
    values.iv_security_amount = "";
    resetForm();
    values.iv_address = "";
    values.iv_sanctioned_load = "";
    values.iv_areaType = "";
    values.iv_circle = "";
    values.iv_division = "";
    values.iv_sub_divison = "";
    values.iv_consumer_id = "";
    values.iv_reference_number = "";
    values.iv_applicant_name = "";
    values.iv_father_name = "";
    values.iv_connection_type = "";
    values.iv_tariff_code = "";
    values.iv_tariff_description = "";
    values.iv_applicant_cnic = "";
    values.iv_applicant_phone_no = "";
    values.iv_applicant_email = "";
    values.iv_net_bill = "";
    values.iv_arrears = "";
    values.iv_due_date = "";
    values.iv_copy_of_paid_bill = null;
    values.iv_applicant_cnic_document_front = null;
    values.iv_applicant_cnic_document_back = null;
    values.iv_consumer_status = "";
    values.iv_billing_month = "";
    values.iv_security_amount = "";
    values.iv_KWH_MFG_ID_METER = "";
    values.iv_KWH_METER_CODE = "";
    values.iv_KWH_METER_LOC_CD = "";
    values.iv_KWH_STATUS = "";
    values.iv_KWH_METER_RANGE = "";
    values.iv_KWH_READING = "";
    values.iv_KWH_MF = "";
    values.iv_KVARH_READING = "";
    values.iv_MDI_READING = "";
    values.iv_MDI_CUM_READ = "";
    values.iv_meter_serial_no = "";
    setApplicantCnicDocumentBack("");
    setApplicantCnicDocumentFront("");
    setApplicantCnicDocumentBackThumbnail(null);
    setApplicantCnicDocumentFrontThumbnail(null);
  };

  // Formik form submission and new connection API calling
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    isSubmitting,
    isValid,
    setTouched,
    submitCount,
    setValues,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_connection_type: Yup.string().required(
        "Connection type is compulsory.",
      ),
      iv_reference_number: Yup.string().when("iv_search_by", {
        is: () => searchBy === "referenceNo",
        then: Yup.string()
          .min(14, "Reference No. must be 14 digits.")
          .max(14, "Reference No. must be 14 digits.")
          .required("Enter reference number."),
        otherwise: Yup.string().optional(),
      }),
      iv_consumer_id: Yup.string().when("iv_search_by", {
        is: () => searchBy === "consumerId",
        then: applyCustomerIdLengthValidation(Yup.string(), userCompany).required(
          "Enter consumer Id.",
        ),
        otherwise: Yup.string().optional(),
      }),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_net_bill: Yup.mixed().required("Can't apply! No current bill."),
      iv_arrears: Yup.mixed().optional(""),
      iv_sanctioned_load: Yup.string().required("Load is required."),
      iv_applicant_phone_no: Yup.string()
        .required("Phone number is required")
        .min(11, "Phone number must be 11 digits")
        .max(11, "Phone number must be 11 digits")
        .matches(
          /^03[0-9]{9}$/,
          "Enter valid phone number starting with 03 (e.g., 03001234567)",
        ),
      iv_applicant_cnic_front: Yup.mixed().required(
        "Applicant CNIC Front is required",
      ),
      iv_applicant_cnic_back: Yup.mixed().required(
        "Applicant CNIC Back is required",
      ),
      iv_applicant_status: Yup.mixed()
        .required("Please select applicant status.")
        .oneOf(applicantStatusForValidation, "Please select a valid option"),
    }),
    onSubmit: async (formValues, { setSubmitting, resetForm }) => {
      // Prevent submission if form is invalid
      if (!isValid) {
        // Touch all fields to show all errors
        Object.keys(formValues).forEach((field) => {
          setTouched({ ...touched, [field]: true });
        });
        setSubmitting(false);
        return;
      }

      setViewBackdrop(true);

      if (!applicantCnicFrontThumbnail) {
        setApplicantCnicFrontError(
          "Upload Applicant CNIC front document in JPG, PNG or PDF.",
        );
        setViewBackdrop(false);
        setSubmitting(false);
        return;
      }
      if (!applicantCnicBackThumbnail) {
        setApplicantCnicBackError(
          "Upload Applicant CNIC back document in JPG, PNG or PDF.",
        );
        setViewBackdrop(false);
        setSubmitting(false);
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        referenceNo: formValues.iv_reference_number,
        customerId: formValues.iv_consumer_id,
        applicationProgressId: 1,
        submittedThrough: portalName,
        consumerName: formValues.iv_applicant_name,
        consumerFatherName: formValues.iv_father_name,
        consumerCNIC: formValues.iv_applicant_cnic,
        consumerAddress: formValues.iv_address,
        applicantMobileNo: formValues.iv_applicant_phone_no,
        cfcId: csc,
        currentStatus: formValues.iv_consumer_status,
        meterType: formValues.iv_meter_type,
        applicantStatus: formValues.iv_applicant_status,
        tariffCode: formValues.iv_tariff_code,
        tariffDesc: formValues.iv_tariff_description,
        connectionCategory: formValues.iv_connection_type,
        disconnectionDate: formValues.iv_disconnection_date,
        meterSerialNo: formValues.iv_meter_serial_no,
        applicantCNICFront: applicantCnicFrontThumbnail,
        applicantCNICBack: applicantCnicBackThumbnail,
        paidBillImage: "",
        securityAmount: parseInt(formValues.iv_security_amount, 10),
        arrearsAmountAtDiscDate: parseInt(formValues.iv_arrears, 10),
        sanctionedLoad: formValues.iv_sanctioned_load,
        billMonth: formValues.iv_billing_month,
        phase: formValues.iv_phase,
        areaType: formValues.iv_areaType,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "rco/registerReconnectionApplication",
          requestOptions,
        );

        if (!response.ok) {
          const errorData = await response.json();
          setError(errorData.message || "Submission failed");
          setViewBackdrop(false);
          setSubmitting(false);
          return;
        }

        const result = await response.json();

        if (result.status === "200") {
          const applicationID = result.applicationId;
          setApplicationId(applicationID);
          setReconnectionPopUp(true);
          printApplicationReceipt(
            formValues,
            applicationID,
            userId,
            referenceNumber,
          );
          resetForm();
          setDefaultCircle(null);
          setDefaultDivision(null);
          setSubDivision({ code: null, name: "" });
          setApplicantCnicDocumentFront("");
          setApplicantCnicDocumentBack("");
          setApplicantCnicDocumentFrontThumbnail("");
          setApplicantCnicDocumentBackThumbnail("");
        } else {
          setError(
            result.message?.startsWith(
              "Disconnection date can not be null or empty",
            )
              ? result.message
              : "The meter is already connected.",
          );
        }
      } catch (error) {
        setError("An error occurred while submitting the form.");
      } finally {
        setViewBackdrop(false);
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    return () => setSubmitAttempted(false);
  }, []);

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true);
        const lists = await subDivAPI(subDivList);
        setHierarchyList(lists.hierarchyList);
        setCircleList(lists.circleList);
        setDivisionList(lists.divisionList);
        setSubDivisionList(lists.subDivisionList);
        setViewBackdrop(false);
      }
    };
    loadSubDivs();
  }, []);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter((division) => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(
          (d) => d.code === division.divisionCode,
        );
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { ignorePunctuation: true }),
    );

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(
        (subDivision) => subDivision.divisionCode === defaultDivision.code,
      )
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(
          (s) => s.code === subDivision.subDivisionCode,
        );
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { ignorePunctuation: true }),
    );

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  // Calling Billing API to fetch near by details
  useEffect(() => {
    if (referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(
        (item) => item.code === parseInt(circleCode),
      );

      if (!circleObject) {
        setError(`Circle not found with code: ${circleCode}. Contact Admin!`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(
            (c) => c.code === division.divisionCode,
          );
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
      );
      let defDivision = sortedDivisionArray.find(
        (item) => item.code === parseInt(divisionCode),
      );

      if (!defDivision) {
        // Handle division not found
        setError(
          `Division not found with code: ${divisionCode}. Contact Admin!`,
        );
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(
            (c) => c.code === subDivision.subDivisionCode,
          );
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
      );

      let subDivisionObject = sortedSubDivisionArray.find(
        (item) => item.code === parseInt(subDivisionCode),
      );
      if (!subDivisionObject) {
        // Handle subdivision not found
        setError(
          `Subdivision not found with code: ${subDivisionCode}. Contact Admin!`,
        );
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    if (searchBy !== "consumerId") return;
    if (isValidCustomerIdLength(values.iv_consumer_id, userCompany)) {
      referenceApi();
    } else {
      setDefaultCircle("");
      setDefaultDivision("");
      setError("");
      setSubDivision("");
      setIsNetMetering(false);
      values.iv_payment_13 = "";
      values.iv_meter_type = "";
      values.iv_phase = "";
      values.iv_disconnection_date = "";
      values.iv_arrears_at_discon = "";
      values.iv_due_date = "";
      values.iv_security_amount = "";
      values.iv_address = "";
      values.iv_sanctioned_load = "";
      values.iv_areaType = "";
      values.iv_circle = "";
      values.iv_consumer_status = "";
      values.iv_arrears = "";
      values.iv_net_bill = "";
      values.iv_reconnection_fee = "";
      values.iv_fixed_charges = "";
      values.iv_billing_month = "";
      values.iv_meter_serial_no = "";
      values.iv_security_amount = "";
      values.iv_division = "";
      values.iv_sub_divison = "";
      // values.iv_reference_number = "";
      values.iv_applicant_name = "";
      values.iv_father_name = "";
      values.iv_applicant_cnic = "";
      values.iv_applicant_phone_no = "";
      values.iv_applicant_email = "";
      values.iv_due_date = "";
      values.iv_copy_of_paid_bill = null;
      values.iv_applicant_cnic_document_front = null;
      values.iv_applicant_cnic_document_back = null;
      values.iv_connection_type = "";
      values.iv_tariff_description = "";
      values.iv_tariff_code = "";
      values.iv_bill_month = "";
      values.iv_cc_code = "";
      values.iv_KWH_MFG_ID_METER = "";
      values.iv_KWH_METER_CODE = "";
      values.iv_KWH_METER_LOC_CD = "";
      values.iv_KWH_STATUS = "";
      values.iv_KWH_METER_RANGE = "";
      values.iv_KWH_READING = "";
      values.iv_KWH_MF = "";
      values.iv_KVARH_READING = "";
      values.iv_MDI_READING = "";
      values.iv_MDI_CUM_READ = "";
      setApplicantCnicDocumentFrontThumbnail(null);
      setApplicantCnicDocumentBackThumbnail(null);
      setApplicantCnicDocumentBack("");
      setApplicantCnicDocumentFront("");
      setReferenceNumber("");
      setCustomerId(null);
      setCheckArrears(null);
      setDisconnectionStatus(null);
    }
  }, [values.iv_consumer_id, searchBy, selectedAdminCompanyCode]);

  useEffect(() => {
    if (searchBy !== "referenceNo") return;
    if (values.iv_reference_number.length === 14) {
      referenceApi();
    } else {
      setDefaultCircle("");
      setDefaultDivision("");
      setError("");
      setSubDivision("");
      setIsNetMetering(false);
      values.iv_payment_13 = "";
      values.iv_meter_type = "";
      values.iv_phase = "";
      values.iv_disconnection_date = "";
      values.iv_arrears_at_discon = "";
      values.iv_due_date = "";
      values.iv_security_amount = "";
      values.iv_address = "";
      values.iv_sanctioned_load = "";
      values.iv_areaType = "";
      values.iv_circle = "";
      values.iv_division = "";
      values.iv_sub_divison = "";
      // values.iv_consumer_id = "";
      values.iv_applicant_name = "";
      values.iv_father_name = "";
      values.iv_applicant_cnic = "";
      values.iv_applicant_phone_no = "";
      values.iv_applicant_email = "";
      values.iv_net_bill = "";
      values.iv_consumer_status = "";
      values.iv_arrears = "";
      values.iv_net_bill = "";
      values.iv_reconnection_fee = "";
      values.iv_fixed_charges = "";
      values.iv_billing_month = "";
      values.iv_meter_serial_no = "";
      values.iv_security_amount = "";
      values.iv_copy_of_paid_bill = null;
      values.iv_applicant_cnic_document_front = null;
      values.iv_applicant_cnic_document_back = null;
      values.iv_connection_type = "";
      values.iv_tariff_description = "";
      values.iv_tariff_code = "";
      values.iv_bill_month = "";
      values.iv_cc_code = "";
      values.iv_KWH_MFG_ID_METER = "";
      values.iv_KWH_METER_CODE = "";
      values.iv_KWH_METER_LOC_CD = "";
      values.iv_KWH_STATUS = "";
      values.iv_KWH_METER_RANGE = "";
      values.iv_KWH_READING = "";
      values.iv_KWH_MF = "";
      values.iv_KVARH_READING = "";
      values.iv_MDI_READING = "";
      values.iv_MDI_CUM_READ = "";
      setCheckArrears(null);
      setApplicantCnicDocumentFrontThumbnail(null);
      setApplicantCnicDocumentBackThumbnail(null);
      setApplicantCnicDocumentBack("");
      setApplicantCnicDocumentFront("");
      setReferenceNumber("");
      setCustomerId(null);
      setDisconnectionStatus(null);
    }
  }, [values.iv_reference_number, searchBy]);

  useEffect(() => {
    if (
      (isValidCustomerIdLength(values.iv_consumer_id, userCompany) ||
        values.iv_reference_number.length === 14) &&
      values.iv_applicant_phone_no.length === 11
    ) {
      setCoaStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setCoaStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [values]);

  useEffect(() => {
    if (applicantCnicFront && applicantCnicBack) {
      setCoaStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setCoaStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [applicantCnicFront, applicantCnicBack]);

  const connectionTypeMap = {
    D: "Domestic",
    C: "Commercial",
    I: "Industrial",
    A: "Agricultural",
  };

  const referenceApiRequestRef = useRef(0);

  const getDisconnectionRow = (apiResponse) =>
    apiResponse?.data?.[0] ?? apiResponse?.rows?.[0] ?? null;

  const applyDisconnectionDetails = (dicConDetails) => {
    const refNo = dicConDetails.REF_NO?.replace(/ /g, "").slice(0, 14) ?? "";

    setReferenceNumber(refNo);
    setCustomerId(dicConDetails.CUSTOMER_ID);
    setCheckArrears(dicConDetails.ARREAR);

    const phase =
      dicConDetails.SAN_LOAD < 5
        ? "Single Phase"
        : dicConDetails.SAN_LOAD >= 5
          ? "Three Phase"
          : "";

    setValues((prev) => ({
      ...prev,
      iv_applicant_name: dicConDetails.CONSUMER_NAME,
      iv_father_name: dicConDetails.FNAME,
      iv_applicant_cnic: dicConDetails.NEW_NIC_NO,
      iv_address: dicConDetails.CUSTOMER_ADDRESS,
      iv_connection_type: connectionTypeMap[dicConDetails?.CON_CAT] || "-",
      iv_reference_number: refNo,
      iv_consumer_id: dicConDetails.CUSTOMER_ID,
      iv_meter_type: dicConDetails.METER_TYPE,
      iv_tariff_code: dicConDetails.TARIFF,
      iv_tariff_description: dicConDetails.TARIFFDESC,
      iv_arrears: dicConDetails.ARREAR,
      iv_net_bill: dicConDetails.ARREAR,
      iv_due_date: dicConDetails.DUE_DT,
      iv_consumer_status: dicConDetails.CONSUMER_STATUS,
      iv_disconnection_date: dicConDetails.DISCON_DATE,
      iv_billing_month: dicConDetails.BILLING_MONTH,
      iv_sanctioned_load: dicConDetails.SAN_LOAD,
      iv_areaType: dicConDetails.RU_CD,
      iv_security_amount: dicConDetails.SEC_AMOUNT,
      iv_meter_serial_no: dicConDetails.METER_SERIAL_NO,
      iv_reconnection_fee: getReconnectionFee(
        rcoVoucherRates,
        dicConDetails.ARREAR,
      ),
      iv_phase: phase,
      iv_fixed_charges: getFixedChargesForRco(
        dicConDetails.TARIFFDESC?.slice(0, 3),
        dicConDetails.PHASE,
      ),
    }));

    if (dicConDetails.NET_METER_CD === "01") {
      setError("Reconnection is not allowed for netmetering");
      setIsNetMetering(true);
      setDisconnectionStatus(true);
    } else if (dicConDetails.DISCON_DATE) {
      setDisconnectionStatus(true);
      setIsNetMetering(false);
      setError("");
    } else {
      setDisconnectionStatus(false);
      setIsNetMetering(false);
      setError("Meter is already connected.");
    }
  };

const referenceApi = async () => {
  const requestId = ++referenceApiRequestRef.current;
  const adminOfficeCode = resolveAdminDiscoOfficeCode(
    userCode,
    roleId,
    selectedAdminCompanyCode || readPersistedAdminCompanyCode(),
  );
  if (searchBy === "consumerId") {
    if (!values.iv_consumer_id) return;
    setViewBackdrop(true);
    let apiResponse = await disconnectionDetails(
      token,
      values.iv_consumer_id,
      adminOfficeCode,
      userCode,
      roleId,
    );
    if (apiResponse?.status === "400" || apiResponse?.status === 400) {
      setError(
        apiResponse?.message ||
          "The consumer is not currently disconnected or no disconnection record exists.",
      );
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    if (
      apiResponse?.status === "Data Not Found." ||
      apiResponse?.message === "Data Not Found." ||
      apiResponse?.Message === "Data Not Found."
    ) {
      setError("Data Not Found.");
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    if (!(apiResponse?.status === "200" || apiResponse?.status === 200)) {
      setError(apiResponse?.message || "Unable to fetch disconnection details.");
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    const dicConDetails = getDisconnectionRow(apiResponse);
    if (!dicConDetails) {
      setError(
        apiResponse?.message ||
          "The consumer is not currently disconnected or no disconnection record exists.",
      );
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    if (requestId !== referenceApiRequestRef.current) return;

    if (
      dicConDetails.DISCON_DATE !== "" &&
      dicConDetails.DISCON_DATE !== null &&
      dicConDetails.DISCON_DATE !== undefined
    ) {
      applyDisconnectionDetails(dicConDetails);
    } else {
      setError(
        "The consumer is not currently disconnected or no disconnection record exists.",
      );
      setIsNetMetering(false);
      setDisconnectionStatus(false);
    }
    setViewBackdrop(false);
  }
  
  if (searchBy === "referenceNo") {
    if (!values.iv_reference_number) return;
    setViewBackdrop(true);
    let apiResponse = await disconnectionDetails(
      token,
      values.iv_reference_number,
      adminOfficeCode,
      userCode,
      roleId,
    );
    if (apiResponse?.status === "400" || apiResponse?.status === 400) {
      setError(
        apiResponse?.message ||
          "The consumer is not currently disconnected or no disconnection record exists.",
      );
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    if (
      apiResponse?.status === "Data Not Found." ||
      apiResponse?.message === "Data Not Found." ||
      apiResponse?.Message === "Data Not Found."
    ) {
      setError("Data Not Found.");
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    if (!(apiResponse?.status === "200" || apiResponse?.status === 200)) {
      setError(apiResponse?.message || "Unable to fetch disconnection details.");
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    const dicConDetails = getDisconnectionRow(apiResponse);
    if (!dicConDetails) {
      setError(
        apiResponse?.message ||
          "The consumer is not currently disconnected or no disconnection record exists.",
      );
      setIsNetMetering(false);
      setDisconnectionStatus(false);
      setViewBackdrop(false);
      return;
    }

    if (requestId !== referenceApiRequestRef.current) return;

    if (
      dicConDetails.DISCON_DATE !== "" &&
      dicConDetails.DISCON_DATE !== null &&
      dicConDetails.DISCON_DATE !== undefined
    ) {
      applyDisconnectionDetails(dicConDetails);
    } else {
      setError(
        "The consumer is not currently disconnected or no disconnection record exists.",
      );
      setIsNetMetering(false);
      setDisconnectionStatus(false);
    }
    setViewBackdrop(false);
  }
};

  const printApplicationReceipt = (
    values,
    applicationID,
    userId,
    referenceNo,
  ) => {
    let DiscoCode = values.iv_sub_divison.toString().slice(0, 2);
    const doc = new jsPDF({ compressPdf: true });
    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(
      getLogo(DiscoCode),
      "PNG",
      logoX,
      height,
      logoWidth,
      logoHeight,
    ); // Adjust the position and size of the logo image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Reconnection Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      },
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height,
    );
    doc.text(
      values.iv_sub_divison.toString() +
        " / " +
        subdivisionName(values.iv_sub_divison, subDivisionsArray),
      // 'Sub Division Name',
      padding + leftMargin,
      height,
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate =
      currentDate.getDate() +
      " " +
      [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ][currentDate.getMonth()] +
      " " +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userId, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight(),
      );
    }

    const pdfBlob = doc.output("blob");
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, "_blank");
  };

  const handleClose = () => {
    setReconnectionPopUp(false);
    navigate("/reconnection-table");
  };

  const downloadVoucherPDF = async (applicationId) => {
    setViewBackdrop(true);

    let application = {};
    try {
      application = await SearchIndividualApplication(
        token,
        applicationId,
        "13",
      );
    } catch (e) { /* ignored */ }

    try {
      let rcoVoucherDets;
      let rcoVoucherExpiryFlag;
      await callAsyncGetRCOFeeVoucherAPI(applicationId).then((response) => {
        rcoVoucherDets = response.rcoVoucherDets;
        rcoVoucherExpiryFlag = response.rcoVoucherExpiryFlag;
      });
      //#region text
      // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
      let officeCode = application.divisionCode.toString();
      let officeName = divisionName(parseInt(officeCode), subDivisions);
      let authorizedByName = "System";
      let authorizedByDesignation = rcoVoucherDets.approvedByDesignation
        ? rcoVoucherDets.approvedByDesignation
        : "-";
      let dateToPrint = rcoVoucherDets.issueDate
        ? numberFormatting(new Date(rcoVoucherDets.issueDate))
        : "---";
      let stampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateToPrint,
      );

      const fontSize = 8;
      const doc = new jsPDF({ compressPdf: true });
      if (rcoVoucherDets.issueDate) {
        doc.addImage(stampData, "PNG", 20, 100, 55, 40); // Add image to PDF (x, y, width, height)
        doc.addImage(stampData, "PNG", 140, 185, 55, 40); // Add image to PDF (x, y, width, height)
      }

      //#region Line 1
      var padding = 10;
      var line2Height = 10;
      var lineHeightIncreament = 5;
      doc.setFontSize(fontSize);
      doc.text(
        "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
        padding,
        line2Height,
        {},
      );
      doc.text(
        companyName(applicationId.slice(3, 5)).concat(
          application.sanctionedLoad < 15
            ? "(" +
                applicationId.slice(3, 8) +
                "-" +
                subdivisionName(
                  parseInt(application.subDivisionCode),
                  subDivisions,
                ) +
                ")"
            : "(" +
                applicationId.slice(3, 7) +
                "-" +
                divisionName(parseInt(application.divisionCode), subDivisions) +
                ")",
        ),
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 2
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "(Department of Electricity)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 3
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 12;
      var text1 = "RCO Voucher Serial No.: ";
      var text2 = rcoVoucherDets.applicationId;
      var text3 = "Application Id: ";
      var text4 = applicationId;
      var text5 = "Apply Date: ";
      var text6 = convertDate(application.creationDate);

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 3.35;
      var text1 = "Voucher Issuance Date: ";
      var text2 = rcoVoucherDets.issueDate
        ? convertDate(rcoVoucherDets.issueDate)
        : "-";
      var text3 = "Application Type: ";
      var text4 = application.applicationType
        ? applicationName(application.applicationType)
        : "-";
      var text5 = "(New Connection, Reconnection etc.): ";
      var text6 = application.applicationType
        ? applicationName(application.applicationType)
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "Reference No.: ";
      var text2 = application.referenceNo ? application.referenceNo : "-";
      var text3 = "Consumer Mobile No.: ";
      var text4 = application.applicantMobileNo
        ? application.applicantMobileNo
        : "-";
      var text5 = "Connection type: ";
      var text6 = application.connectionCategory
        ? application.connectionCategory
        : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
        line2Height + 1,
      );
      //#endregion

      //#region Line 6
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 7;
      var text1 =
        "(under which the funds are to be deposited in the bank with the concerned officer of the department)";
      var text2 = " ";
      var text3 = " ";

      doc.setFontSize(6);
      doc.text(text1, padding, line2Height);
      doc.setFontSize(fontSize);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + lineSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text3) + lineSpace * 2),
        line2Height + 1,
      );

      //#endregion

      //#region Line 7
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 22.25;
      var text1 = `Department's approved Bank name: `;
      var text2 = rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-";
      var text3 = "Sanctioned Load (kW): ";
      var text4 = application.sanctionedLoad
        ? application.sanctionedLoad.toString()
        : "|";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 8
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 22;
      var text1 = `Department's Revenue Officer: `;
      var text2 = divisionName(
        parseInt(application.divisionCode),
        subDivisions,
      );
      var text3 = " ";
      var text4 = " ";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 9
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var text1 = ` `;
      var text2 = " ";
      var text3 = "Tariff : ";
      var text4 = application.tariffCode ? application.tariffCode : "-";

      // doc.text(text1, padding, line2Height);
      // doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      // doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 10
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        "RCO Fee Voucher",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 11
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        "(Notification of Approval Application Under Guarantee)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 12
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        `Applicant's part`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 13
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var text1 = `Mr. / Mrs.`;
      var text2 = application.consumerName
        ? application.consumerName
            .concat(" | ")
            .concat(application.consumerAddress)
        : "|";
      var text3 = ``;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.setFontSize(6);
      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      //#endregion

      //#region Line 14
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var text1 = `You are hereby informed that your application for reconnection whose particulars are mentioned above has been approved by the system on the following conditions.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 15
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `1. You should deposit the following amounts in the approved bank of the RO Office department within [word1] days from the date of issue of this notice and inform the office with the receipt number and date of your payment.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[word1]", noOfDays);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 16
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `A. Ree Connection Fee as per CSM ______________ and Fixed Charges _______________ PKR. (this amount is to be deposited in the department's approved bank).`;
      var text2 = rcoVoucherDets.rcoFeeAmount
        ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
        : "0";
      var text3 = rcoVoucherDets.fixedChargesAmount
        ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
        : "0";
      var lines = doc.splitTextToSize(text1, maxWidth);
      doc.setFont("helvetica", "bold");
      doc.text(text2, 60, line2Height);
      doc.text(text3, 110, line2Height);
      doc.setFont("helvetica", "normal");
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace(
          "[rcoFeeAmount]",
          rcoVoucherDets.rcoFeeAmount
            ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
            : "0",
        );
        lineText = lineText.replace(
          "[fixedChargesAmount]",
          rcoVoucherDets.fixedChargesAmount
            ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
            : "0",
        );
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }

      //#endregion

      //#region Line 22
      doc.text(
        `(Irrelevant should be cut down)`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 23
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfMonth = "1";
      var text1 = `If you do not comply with the above conditions in response to the RCO fee voucher within the prescribed period, your application form for reconnection will not be considered with the serial number allotted. RCO Fee Voucher thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 24
      doc.setFontSize(fontSize);
      var text1 = `Regards`;
      var spaceLeft = 100;
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 25
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var text1 =
        "Revenue Office " +
        applicationId.slice(3, 7) +
        "-" +
        divisionName(parseInt(application.divisionCode), subDivisions);
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 26
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var text1 = " ";
      var text2 =
        "Account Section" +
        "(" +
        applicationId.slice(3, 7) +
        " - " +
        divisionName(parseInt(application.divisionCode), subDivisions) +
        ") RO MEPCO";
      doc.text(text1, padding, line2Height);
      doc.text(text2, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 27
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      spaceLeft = 10;
      var text1 =
        "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 28
      lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
        padding,
        line2Height,
        {},
      );
      doc.text(
        "For Bank Use Only",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 29
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "(The concerned bank will separate this layer from the RCO Voucher and send it to the revenue officer along with its bank scroll)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 30
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var spaceLeft = 50;

      var text1 = `1. Applicant's Name and Complete address `;
      var text2 = application.consumerName
        ? application.consumerName
            .concat(" | ")
            .concat(application.consumerAddress)
        : "|";
      var text3 = `Details of paid amount`;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.setFontSize(6);
      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
        line2Height,
      );
      //#endregion

      //#region Line 31
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "2. Application Id: ";
      var text2 = application.applicationId ? application.applicationId : "-";
      var text3 = "Date: ";
      var text4 = application.creationDate
        ? convertDate(application.creationDate)
        : "-";
      var text5 = "1. Fee Voucher Amount:";
      var text6 = rcoVoucherDets.rcoFeeAmount
        ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
        : "0";
      var leftSpace = 40;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.setFont("helvetica", "bold");
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
        line2Height,
      );
      doc.setFont("helvetica", "normal");
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 32
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "3. RCO Fee Voucher No.: ";
      var text2 = rcoVoucherDets.applicationId
        ? rcoVoucherDets.applicationId
        : "-";
      var text3 = "Date: ";
      var text4 = rcoVoucherDets.issueDate
        ? convertDate(rcoVoucherDets.issueDate)
        : "-";
      var text5 = "2. Fixed Charges: ";
      var text6 = rcoVoucherDets.fixedChargesAmount
        ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
        : "0";
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1,
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.setFont("helvetica", "bold");
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
        line2Height,
      );
      doc.setFont("helvetica", "normal");
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 33
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "4. Reference No.: ";
      var text2 = application.referenceNo ? application.referenceNo : "-";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = " ";
      var leftSpace = 10;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );

      // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(
        text5,
        doc.getTextWidth(text2) +
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height,
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
        line2Height + 1,
      );
      //#endregion

      //#region Line 34
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "5. Approved bank name and address:";
      var text2 = rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height,
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1,
      );
      //#endregion

      //#region Line 35
      doc.setFontSize(fontSize);
      var line2Height =
        line2Height + lineHeightIncreament + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 =
        application.sanctionedLoad < 15
          ? "                                                                                 "
          : "                                                                                  ";
      // var text1 = application.sanctionedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = "Signature Bank Officer ";
      var leftSpace = 20;
      doc.text(text1, padding, line2Height);
      doc.text(
        text6,
        doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          +leftSpace,
        line2Height,
      );
      //#endregion

      //#region Line 36
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = " ";
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = " ";
      var leftSpace = 10;
      doc.setFontSize(6);
      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 37
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      spaceLeft = 10;
      var text1 =
        "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 38
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "DUE Date: " + convertDate(rcoVoucherDets.dueDate),
        padding,
        line2Height,
        {},
      );
      doc.text(
        `Applicant's Response`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        },
      );
      //#endregion

      //#region Line 39
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var text1 = `1. I/We have submitted the RCO Fee Voucher of [rcoFeeAmount] and fixed Charges of [fixedChargesAmount] only in the department's approved bank [roBankName] by receipt no. _______________________________________ on date _______________________________.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace(
          "[rcoFeeAmount]",
          rcoVoucherDets.rcoFeeAmount
            ? numberFormatting(rcoVoucherDets.rcoFeeAmount)
            : "0",
        );
        lineText = lineText.replace(
          "[fixedChargesAmount]",
          rcoVoucherDets.fixedChargesAmount
            ? numberFormatting(rcoVoucherDets.fixedChargesAmount)
            : "0",
        );
        lineText = lineText.replace(
          "[roBankName]",
          rcoVoucherDets.roBankName ? rcoVoucherDets.roBankName : "-",
        );
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 47
      doc.setFontSize(6);
      lineHeightIncreament = 2;
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
      var text1 =
        "NOTE - Computer generated Fee Voucher, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said application is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
      var lineSpace = 6.6;
      var lines = doc.splitTextToSize(text1, maxWidth);
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      window.open(pdfDataUrl, "_blank");

      //#endregion
    } catch (e) { /* ignored */ }
    setViewBackdrop(false);
  };

  const callAsyncGetRCOFeeVoucherAPI = async (applicationId) => {
    let rcoFeeVoucherDetails = {
      rcoVoucherDets: {},
      rcoVoucherExpiryFlag: 0,
    };
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/getRCOFeeVocher", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "200") {
            rcoFeeVoucherDetails.rcoVoucherDets = result.data[0];
            rcoFeeVoucherDetails.rcoVoucherExpiryFlag =
              result.rcoVoucherExpiryFlag ? result.rcoVoucherExpiryFlag : 0;
          } 
        })
        .catch(() => {});
    } catch (e) { /* ignored */ }
    return rcoFeeVoucherDetails;
  };

  const [installmentsStatusBarArray, setInstallmentsStatusBarArray] = useState([
    {
      title1: "APPLICATION",
      title2: "DETAIL",
      status: 0,
    },
    {
      title1: `APPLICANT's`,
      title2: "CNIC",
      status: 0,
    },
  ]);

  const renderUploadSlot = ({
    file,
    thumbnail,
    onClear,
    onChange,
    inputId,
    inputName,
    buttonLabel = 'Upload',
    validationError,
    clientError,
    altText,
  }) => (
    <div className="upload-wrap">
      {file ? (
        <Button
          component="label"
          startIcon={
            <CloseIcon className="button-with-image" onClick={onClear} />
          }
        >
          {thumbnail && isImage(file) ? (
            <div className="btn-div">
              <img src={thumbnail} alt={altText} width="80" />
            </div>
          ) : isPdf(file) ? (
            <div className="btn-div">
              <img src={pdfIcon} alt="PDF" width="80" />
            </div>
          ) : (
            <span>Other file type</span>
          )}
        </Button>
      ) : (
        <>
          <Button
            variant="outlined"
            component="label"
            startIcon={<FileUploadOutlinedIcon />}
            className="btn"
          >
            {buttonLabel}
            <input
              hidden
              accept={documentExtensions}
              id={inputId}
              name={inputName}
              type="file"
              onChange={onChange}
            />
          </Button>
          {clientError ? <Box className="documentError">{clientError}</Box> : null}
          {validationError ? <Box className="documentError">{validationError}</Box> : null}
        </>
      )}
    </div>
  );

  return (
    <>
      <Grid container className="rco-page" sx={{ width: '100%', maxWidth: '100%' }}>
        <Box className="rco-container" sx={{ width: '100%', maxWidth: '100%' }}>
          <h3 className="heading rco-page-title">{pageTitle}</h3>
          <div className="rco-stepper-wrap">
            <StepProgressBar array={coaStatusBarArray} pageName="RCO Form" />
          </div>
          <form onSubmit={handleSubmit} noValidate className="rco-form">
            <div className="section-card section-card--accent">
              <div className="section-title">Applicant&apos;s Detail</div>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              errors={errors}
              values={values}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
              allowedSearchBy={["consumerId"]}
              showSubmitErrors={submitAttempted || submitCount > 0}
              layoutVariant="rco"
              showStatusAfterAddress
            />
            </div>

            {disconnectionStatus === true && (
              <div className="section-card section-card--bill">
                <div className="section-title">Bill Detail</div>
                <Grid
                  container
                  className="container rco-bill-detail-row"
                  spacing={2}
                  alignItems="flex-start"
                >
                  <Grid item xs="auto" className="rco-bill-detail-col">
                    <div className="field-wrap rco-bill-arrears-field">
                      <label className="fieldLabel">
                        Arrears At Time of Disconnection
                      </label>
                      <div className="rco-bill-detail-control bill-field-row">
                        <TextField
                          name="iv_arrears"
                          required
                          type="text"
                          onBlur={handleBlur}
                          value={
                            values.iv_arrears
                              ? numberFormatting(values.iv_arrears)
                              : ""
                          }
                          disabled
                          className="textInputField1 bill-arrears-input"
                        />
                        {checkArrears !== null &&
                          checkArrears !== undefined && (
                            <Button
                              className="bill-download-btn"
                              variant="contained"
                              color="primary"
                              startIcon={<DownloadIcon />}
                              onClick={() => downloadBill(referenceNumber)}
                            >
                              Bill
                            </Button>
                          )}
                      </div>
                      <Box className="from-Error">
                        {errors.iv_arrears && touched.iv_arrears
                          ? errors.iv_arrears
                          : null}
                      </Box>
                    </div>
                  </Grid>

                  <Grid item xs="auto" className="rco-bill-detail-col">
                    <div className="field-wrap">
                      <label className="fieldLabel">Due Date</label>
                      <div className="rco-bill-detail-control">
                        <TextField
                          name="iv_due_date"
                          required
                          type="text"
                          onBlur={handleBlur}
                          value={
                            values.iv_due_date
                              ? convertDate(values.iv_due_date)
                              : ""
                          }
                          disabled
                          className="textInputField1 rco-bill-date-input"
                        />
                      </div>
                      <Box className="from-Error">
                        {errors.iv_due_date && touched.iv_due_date
                          ? errors.iv_due_date
                          : null}
                      </Box>
                    </div>
                  </Grid>

                  <Grid item xs="auto" className="rco-bill-detail-col">
                    <div className="field-wrap">
                      <label className="fieldLabel">Disconn. Date</label>
                      <div className="rco-bill-detail-control">
                        <TextField
                          name="iv_disconnection_date"
                          required
                          type="text"
                          onBlur={handleBlur}
                          value={
                            values.iv_disconnection_date
                              ? convertDate(values.iv_disconnection_date)
                              : ""
                          }
                          disabled
                          className="textInputField1 rco-bill-date-input"
                        />
                      </div>
                      <Box className="from-Error">
                        {errors.iv_disconnection_date &&
                        touched.iv_disconnection_date
                          ? errors.iv_disconnection_date
                          : null}
                      </Box>
                    </div>
                  </Grid>
                  {/* <Grid item xs={1.1} sx={{ paddingRight: "20px" }}>
                    <Typography className="fieldLabel">
                      Reconnection Fee
                    </Typography>
                    <input
                      name="iv_reconnection_fee"
                      required
                      type="text"
                      onBlur={handleBlur}
                      value={
                        values.iv_reconnection_fee
                          ? numberFormatting(values.iv_reconnection_fee)
                          : ""
                      }
                      disabled
                      className="textInputField1"
                      style={{
                        width: "100%",
                        backgroundColor: "#006ad1", // Set background color here
                        color: "white", // Set background color here
                        borderRadius: "5px",
                        height: "32.5px",
                        border: "1px solid lightgrey",
                        padding: "0px 5px",
                      }}
                    />
                    <Box className="from-Error">
                      {errors.iv_reconnection_fee && touched.iv_reconnection_fee
                        ? errors.iv_reconnection_fee
                        : null}
                    </Box>
                  </Grid>
                  <Grid item xs={1} sx={{ paddingRight: "20px" }}>
                    <Typography className="fieldLabel">
                      Fixed Charges
                    </Typography>
                    <input
                      name="iv_fixed_charges"
                      required
                      type="text"
                      onBlur={handleBlur}
                      value={
                        values.iv_fixed_charges
                          ? numberFormatting(values.iv_fixed_charges)
                          : ""
                      }
                      disabled
                      className="textInputField1"
                      style={{
                        width: "100%",
                        backgroundColor: "#006ad1", // Set background color here
                        color: "white", // Set background color here
                        borderRadius: "5px",
                        height: "32.5px",
                        border: "1px solid lightgrey",
                        padding: "0px 5px",
                      }}
                    />
                    <Box className="from-Error">
                      {errors.iv_fixed_charges && touched.iv_fixed_charges
                        ? errors.iv_fixed_charges
                        : null}
                    </Box>
                  </Grid> */}
                </Grid>
              </div>
            )}

            <div className="section-card section-card--docs">
              <div className="section-title">Required Documents</div>
              <Grid container spacing={2} className="documents-grid">
                <Grid item xs={12}>
                  <label className="fieldLabel doc-grid-label">1- Applicant&apos;s CNIC</label>
                  <div className="doc-grid-uploads cnic-upload-pair">
                    {renderUploadSlot({
                      file: applicantCnicFront,
                      thumbnail: applicantCnicFrontThumbnail,
                      onClear: () => {
                        setApplicantCnicDocumentFront('');
                        setApplicantCnicDocumentFrontThumbnail(null);
                        handleChange({
                          target: { name: 'iv_applicant_cnic_front', value: null },
                        });
                      },
                      onChange: ApplicantCnicDocumentFront,
                      inputId: 'iv_applicant_cnic_front',
                      inputName: 'iv_applicant_cnic_front',
                      buttonLabel: 'Front',
                      validationError: errors.iv_applicant_cnic_front || null,
                      clientError: applicantCnicFrontError || null,
                      altText: 'Applicant CNIC Front',
                    })}
                    {renderUploadSlot({
                      file: applicantCnicBack,
                      thumbnail: applicantCnicBackThumbnail,
                      onClear: () => {
                        setApplicantCnicDocumentBack('');
                        setApplicantCnicDocumentBackThumbnail(null);
                        handleChange({
                          target: { name: 'iv_applicant_cnic_back', value: null },
                        });
                      },
                      onChange: ApplicantCnicDocumentBack,
                      inputId: 'iv_applicant_cnic_back',
                      inputName: 'iv_applicant_cnic_back',
                      buttonLabel: 'Back',
                      validationError: errors.iv_applicant_cnic_back || null,
                      clientError: applicantCnicBackError || null,
                      altText: 'Applicant CNIC Back',
                    })}
                  </div>
                </Grid>
              </Grid>
            </div>

            {error ? (
              <div className="rco-alert-wrap">
                <Error
                  error={error}
                  onClose={() => errorCloses()}
                  backgroundColor="#FFC0CB"
                  textColor="#bb0303"
                  iconColor="#bb0303"
                />
              </div>
            ) : null}

            <div className="submit-area">
              <Button
                className="submit-btn"
                variant="contained"
                type="submit"
                disabled={isSubmitting || isNetMetering}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </Button>
            </div>
          </form>
        </Box>
      </Grid>

      <FormSubmissionSuccessDialog
        open={reconnectionPopUp}
        onClose={handleClose}
        title="RCO request entered"
        trackingId={applicationId}
      />

      <Dialog
        // open={downloadBillPopup}
        // onClose={() => setDownloadBillPopup(false)}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={batchIcon} alt="batchIcon" width="90px" height="70px" />
            <Typography variant="h6" className="groupTitle">
              {" "}
              Unpaid bill exists
            </Typography>
            <h5 className="applicationSubmit">
              {" "}
              If the bill is unpaid, please ensure it is paid before proceeding
              with the application.
            </h5>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "50px",
                backgroundColor: "#006ad1",
                borderRadius: "5px",
                color: "white",
                cursor: "pointer",
                padding: "5px",
              }}
              onClick={(e) => downloadBill(values.iv_reference_number)}
            >
              View Bill
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
};

export default ReconnectionForm;
